"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.READ_NOTIFICATION = exports.PRIVATE_TOKEN_NOTIFICATION = exports.OPEN_NOTIFICATIONS_WINDOW = exports.INSTANT_NOTIFICATION = exports.GET_MEMBER_NOTIFICATIONS_LIST = exports.COUNTER_NOTIFICATION = exports.CLOSE_NOTIFICATIONS_WINDOW = void 0;
var READ_NOTIFICATION = exports.READ_NOTIFICATION = 'READ_NOTIFICATION';
var INSTANT_NOTIFICATION = exports.INSTANT_NOTIFICATION = 'INSTANT_NOTIFICATION';
var PRIVATE_TOKEN_NOTIFICATION = exports.PRIVATE_TOKEN_NOTIFICATION = 'PRIVATE_TOKEN_NOTIFICATION';
var GET_MEMBER_NOTIFICATIONS_LIST = exports.GET_MEMBER_NOTIFICATIONS_LIST = 'GET_MEMBER_NOTIFICATIONS_LIST';
var OPEN_NOTIFICATIONS_WINDOW = exports.OPEN_NOTIFICATIONS_WINDOW = 'OPEN_NOTIFICATIONS_WINDOW';
var CLOSE_NOTIFICATIONS_WINDOW = exports.CLOSE_NOTIFICATIONS_WINDOW = 'CLOSE_NOTIFICATIONS_WINDOW';
var COUNTER_NOTIFICATION = exports.COUNTER_NOTIFICATION = 'COUNTER_NOTIFICATION';